import { Reveal } from "@/components/Reveal";

const shots = [
  { src: "/assets/life-events.jpg", cap: "WILDLY YOURS.", alt: "Dasha hosting a live event with her books" },
  { src: "/assets/life-love.jpg", cap: "MORE LIFE.", alt: "Dasha and her partner at the ocean" },
  { src: "/assets/life-family.jpg", cap: "YOUR LIFE IS THE MASTERPIECE.", alt: "Dasha with her child — motherhood in the vision" },
  { src: "/assets/life-bus-interior.jpg", cap: "PLEASURE IS PART OF THE PLAN.", alt: "Inside the Love Bus parked on the beach" },
  { src: "/assets/life-clients.jpg", cap: "I ACTUALLY LIVE THIS.", alt: "Dasha working with clients inside the Love Bus" },
];

export const InterludeSection = () => (
  <section data-testid="interlude-section" className="overflow-hidden border-y border-white/10 bg-coal py-16 sm:py-20">
    <Reveal className="mb-10 text-center">
      <p className="font-mono text-[11px] tracking-[0.35em] text-cream/50">
        INSIDE A LIFE ACTUALLY BEING LIVED
      </p>
    </Reveal>
    <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 sm:justify-center sm:overflow-visible sm:pb-0">
      {shots.map((s, i) => (
        <Reveal key={s.src} delay={i * 0.06} className="shrink-0 snap-center">
          <figure className={`group relative w-[64vw] overflow-hidden sm:w-[220px] ${i % 2 ? "sm:translate-y-6" : ""} ${i % 2 ? "rotate-[1.5deg]" : "rotate-[-1.5deg]"}`}>
            <img
              src={s.src}
              alt={s.alt}
              loading="lazy"
              data-testid={`interlude-${i + 1}`}
              className="aspect-[3/4] w-full border border-white/10 object-cover transition-transform duration-700 group-hover:scale-[1.04]"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/75 via-transparent to-transparent" />
            <figcaption className="absolute bottom-3 left-0 w-full px-3 text-center font-mono text-[9px] tracking-[0.25em] text-cream">
              {s.cap}
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
